export default function Footer() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const links: Array<{ label: string; id: string }> = [
    { label: "今日热瓜", id: "hot" },
    { label: "事件档案", id: "archive" },
    { label: "最新动态", id: "latest" },
    { label: "吃瓜指南", id: "guide" },
    { label: "关于我们", id: "about" },
    { label: "投稿线索", id: "submit" },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="section-wrap py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                goTo("top");
              }}
              className="flex items-center gap-2.5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 text-lg text-white">
                <i className="ri-goblet-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-serif-editorial text-xl font-black text-foreground-950">天涯吃瓜</span>
                <span className="mt-1 text-[10px] tracking-widest text-foreground-500">事件梳理与来龙去脉</span>
              </span>
            </a>
            <p className="mt-5 max-w-md leading-7 text-foreground-600">
              一个专注八卦汇总、事件梳理与来龙去脉全记录的吃瓜档案站。还原时间线，看清前因后果，
              让每一件热点都有迹可循。
            </p>
            <div className="mt-6 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-2-line", "ri-tiktok-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  onClick={(e) => e.preventDefault()}
                  aria-label="关注我们"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:bg-primary-600 hover:text-white"
                >
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-bold text-foreground-900">快速导航</h3>
            <ul className="mt-5 flex flex-col gap-3">
              {links.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      goTo(l.id);
                    }}
                    className="text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-foreground-900">联系我们</h3>
            <ul className="mt-5 flex flex-col gap-3 text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-600"></i>
                tip@tianya-chigua.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line text-primary-600"></i>
                投稿与意见反馈
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-verified-badge-line text-primary-600"></i>
                事件持续追踪更新
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="section-wrap flex flex-col items-center justify-between gap-3 py-5 text-sm text-foreground-500 sm:flex-row">
          <p>© 2026 天涯吃瓜档案站 · 事件梳理与来龙去脉全记录</p>
          <p className="flex items-center gap-1.5">
            理性吃瓜，拒绝断章取义
            <i className="ri-leaf-line text-secondary-600"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}